module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "db centered-container inter lh-copy"
  }, [_c('akko-header'), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex pv5 justify-center"
  }, [_c('div', {
    staticClass: "shadow-theme-ns ph5 mt0-ns pv5-ns br3 tc box w-50",
    attrs: {
      "id": "complete-card"
    }
  }, [_c('div', {
    staticClass: "cera-round-pro-medium f3 lh-copy fw3 mb2"
  }, [_vm._v("\n        Welcome to AKKO!\n      ")]), _vm._v(" "), _c('img', {
    staticClass: "image-bot",
    attrs: {
      "src": "/static/social/akkobot.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cera-round-pro color-theme f3 lh-copy fw3 mb3"
  }, [_vm._v("\n        IMPORTANT:\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "inter larger-text"
  }, [_vm._v("\n        To complete your plan activation, please follow the instructions in the SMS you just received to your phone.\n        Click the link and use your temporary password to login.\n      ")]), _vm._v(" "), (true) ? _c('div', {
    staticClass: "inter mv4 larger-text"
  }, [_vm._v("\n        Each of the other users you registered received their own SMS with a password and instructions.\n        Each user will need to login and activate their own account from their phone as part of the verification process.\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inter mt4 mb5"
  }, [_vm._v("\n        If you have any questions or need help completing your registration, don't hesitate to reach out to us!\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt4 tc flex justify-center"
  }, [_c('ak-button', {
    staticClass: "w4 mr3",
    attrs: {
      "newPrimary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onPressEmail.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          Email\n        ")]), _vm._v(" "), _c('ak-button', {
    staticClass: "w4",
    attrs: {
      "newSecondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onPressChat.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          FAQs\n        ")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-796b3131","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/RegistrationComplete.vue
// module id = 688
// module chunks = 0